import { emp } from "api/endpoints";
import { importView } from "../utils/misc";

const EmpList = importView("Emp/List");
const EmpForm = importView("Emp/Form");
const RoleList = importView("Role/List");
const RoleForm = importView("Role/Form");
const PrivList = importView("Priv/List");
const PrivForm = importView("Priv/Form");
const ReportUser = importView("ReportUser");
const NotCusts = importView("NotCusts");

const empRoutes = {
  path: "/",
  children: [
    {
      path: emp.emps,
      element: <EmpList />,
    },
    {
      path: `${emp.emp}/:UserId`,
      element: <EmpForm />,
    },
    {
      path: emp.reportUsers,
      element: <ReportUser />,
    },
    {
      path: emp.roles,
      element: <RoleList />,
    },
    {
      path: `${emp.role}/:RoleId`,
      element: <RoleForm />,
    },
    {
      path: emp.privs,
      element: <PrivList />,
    },
    {
      path: `${emp.priv}/:PrivId`,
      element: <PrivForm />,
    },
    {
      path: emp.userNotCust,
      element: <NotCusts />,
    },
  ],
};

export default empRoutes;
